import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginEmployer, checkEmailVerified, checkUserRole } from '../services/authService';
import { useWindowSize, BP } from '../hooks/useWindowSize';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const isMobile = width < BP.mobile;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await loginEmployer(email, password);
      await checkEmailVerified();  // This will sign out and throw if unverified
      await checkUserRole();        // This will sign out and throw if not employer/admin
      navigate('/dashboard');
    } catch (err) {
      if (err.message.includes('Email not verified')) {
        setError('Please verify your email first. Check your inbox or spam folder.');
      } else if (err.message === 'role-denied') {
        setError('This portal is for employers only. Please use the WorkrMatch mobile app.');
      } else {
        setError('Invalid email or password');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#0F1E2E',
      overflowX: 'hidden',
      maxWidth: '100vw',
      boxSizing: 'border-box',
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: isMobile ? '1.5rem' : '2.5rem',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
        width: isMobile ? '90vw' : '100%',
        maxWidth: '400px',
        margin: '0 auto',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img src="/logo192.png" alt="WorkrMatch" width={120} height={120} style={{ borderRadius: '16px', display: 'block', margin: '0 auto 0.25rem' }} />
          <p style={{ fontSize: "14px", color: "#4b5563", margin: "4px 0 0", textAlign: "center" }}>Employer Portal</p>
        </div>
        
        {error && (
          <div style={{ 
            backgroundColor: '#fee2e2', 
            color: '#991b1b', 
            padding: '0.75rem', 
            borderRadius: '4px',
            marginBottom: '1rem'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', fontSize: '14px' }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.65rem 0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '16px'
              }}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', fontSize: '14px' }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.65rem 0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '16px'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              backgroundColor: '#E8590C',
              color: 'white',
              padding: '0.75rem',
              borderRadius: '6px',
              border: 'none',
              fontSize: '16px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.5 : 1
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '1rem', fontSize: '14px', color: '#6b7280' }}>
          Don't have an account?{' '}
          <a href="/register" style={{ color: '#E8590C', textDecoration: 'none' }}>Sign up</a>
        </p>
      </div>
    </div>
  );
}

export default LoginPage;